export const GET_ROLES = 'GET_ROLES';

type GetRolesActionType = {
  type: string,
  payload: {
    pageSize: number,
    currentPage: number,
    withTotalRecords: boolean,
    searchText: string,
    selectedSearchCriteria: string
  }
}

export const getRolesAction: (pageSize: number, currentPage: number, withTotalRecords: boolean, searchText?: string, selectedSearchCriteria?: string) => GetRolesActionType = (pageSize: number, currentPage: number, withTotalRecords: boolean, searchText: string = "", selectedSearchCriteria: string = ""): GetRolesActionType => ({
  type: GET_ROLES,
  payload: {
    pageSize, currentPage, withTotalRecords, searchText, selectedSearchCriteria
  }
})
